export default function getStyleProperty(source: any, key: string, fallback: string = '', computed: boolean = true): string {
    return (source?.[key] ?? fallback) || fallback;
}
